import React, { Component } from 'react';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import ExerciseProgressCircle from '../ExerciseProgressCircle/ExerciseProgressCircle';
import TouchButton from '../TouchButton';

const ExerciseQuestion = React.createClass({

    render: function () {

        let isAssessment = this.props.isAssessment || null;

        if(isAssessment === 'true') {
            isAssessment = false;
        }

        return (
            <div className="exercise-question-area">
                {isAssessment ? <ExerciseProgressCircle/> : null}
                <div className="exercise-question-area--question" dangerouslySetInnerHTML={{__html: this.props.children}}></div>
                <ul className="exercise-question-area--tools">
                    <li><TouchButton className="btn btn-link" title="image"><Glyphicon glyph="picture"/></TouchButton></li>
                    <li><TouchButton className="btn btn-link" title="Edit"><Glyphicon glyph="pencil"/></TouchButton></li>
                    <li><TouchButton className="btn btn-link" title="Erase"><Glyphicon glyph="erase"/></TouchButton></li>
                </ul>
            </div>
        );
    }
});

export default ExerciseQuestion;


/** WEBPACK FOOTER **
 ** ./src/components/ExerciseQuestion/ExerciseQuestion.js
 **/